import { onMounted, onUnmounted, watch } from 'vue';
import { api } from '@/api';
import { createPlanStatePoller } from '@/helpers/planStatePoller';

export const useCrmPlanState = (planId, refresh, isReady = () => true) => {
  const poller = createPlanStatePoller({
    getPlanId: () => planId.value,
    getState: (id) => api.getCrmPlanState(id).then(({ data }) => data),
    refresh,
    isActive: () => isReady() && !document.hidden && document.hasFocus(),
  });

  const onActivate = () => {
    if (!document.hidden && document.hasFocus()) poller.activate();
  };

  watch(planId, () => poller.start());
  watch(isReady, (ready) => {
    if (ready) poller.activate();
  });
  onMounted(() => {
    poller.start();
    window.addEventListener('focus', onActivate);
    document.addEventListener('visibilitychange', onActivate);
  });
  onUnmounted(() => {
    poller.stop();
    window.removeEventListener('focus', onActivate);
    document.removeEventListener('visibilitychange', onActivate);
  });
};
